import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  IconButton,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
} from "@mui/material";
import WhatsApp from "@mui/icons-material/WhatsApp";
import Twitter from "@mui/icons-material/Twitter";
import Instagram from "@mui/icons-material/Instagram";
import Telegram from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CaptchaTikTakToe from "../misc/CaptchaTikTakToe";
import {
  emailVerify,
  saveSubscribeEmail,
} from "../../reduxToolkit/features/auth";
import EmailVerificationDialog from "../EmailVerificationDialog";
import LoadingButton from "@mui/lab/LoadingButton";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import { colors, radii } from "../../theme/designTokens";

export default function ContactUs({ contentSettings }) {
  const dispatch = useDispatch();
  const [subScriptionStatus, setSubscriptionStatus] = useState(false);
  const [subscribeEmail, setSubscribeEmail] = useState("");
  const [agreeSub, setAgreeSub] = useState(true);

  const [formLoading, setFormLoading] = React.useState(false);
  const [customerFormLoading, setCustomerFormLoading] = useState(false);
  const [captchaDlg, setCaptchaDlg] = useState(false);
  const [vCode, setVCode] = useState("");
  const [verifyDlg, setVerifyDlg] = useState(false);
  const [verifyCodeInput, setVerifyCodeInput] = useState("");

  const [, setIsCustomer] = useState(false);

  // Count down
  const [countDownStart, setCountDownStart] = React.useState("");

  const [phoneDlg, setPhoneDlg] = useState(false);

  // Store
  const { webSettings } = useSelector((state) => state.webSettings);
  const { authData, emailResponse } = useSelector((state) => state.auth);

  // LocalData
  const localCustomerData = () => {
    const c = JSON.parse(localStorage.getItem("loginInfo"));
    return c ? c : {};
  };

  const localLangData = () => {
    const c = JSON.parse(localStorage.getItem("langFront"));
    return c ? c : {};
  };

  const handlePhone = () => {
    if (
      contentSettings.footerContactInfo &&
      contentSettings.footerContactInfo.contactNumber &&
      contentSettings.footerContactInfo.contactNumber.length > 0
    ) {
      if (contentSettings.footerContactInfo.contactNumber.length > 1) {
        setPhoneDlg(true);
      } else {
        window.open(
          "tel:" + contentSettings.footerContactInfo.contactNumber[0],
          "_blank"
        );
      }
    }
  };

  const handleSubscriptionClick = () => {
    if (
      localCustomerData()._id &&
      localCustomerData().email === subscribeEmail
    ) {
      setIsCustomer(true);
      setCustomerFormLoading(true);
      handleSubscribe(true);
    } else {
      setIsCustomer(false);
      setCaptchaDlg(true);
    }
  };

  const subscribeUserFunc = () => {
    setCountDownStart(
      new Date().getTime() + (webSettings.verificationInterval || 1) * 60000
    );
    let v = Math.floor(Math.random() * (999999 - 100000 + 1) + 100000);
    setVCode(v);
    v = v * 3875412698;
    dispatch(
      emailVerify({ v, email: subscribeEmail, langId: localLangData()._id })
    );
    setFormLoading(true);
  };

  const handleSubscribe = (isCustomer) => {
    let obj = {
      email: subscribeEmail,
      isCustomer,
      langId: localLangData()._id,
    };
    dispatch(saveSubscribeEmail(obj));
    setTimeout(() => {
      setIsCustomer(false);
      setFormLoading(false);
      setCustomerFormLoading(false);
      setSubscribeEmail("");
    }, 1000);
  };

  // Use Effect
  useEffect(() => {
    if (localCustomerData()._id) {
      if (localCustomerData().subscribed) {
        setSubscriptionStatus(true);
        setSubscribeEmail("");
      } else {
        setSubscriptionStatus(false);
        setSubscribeEmail(localCustomerData().email);
      }
    }
  }, [authData]);

  // Check verification Code
  useEffect(() => {
    if (vCode === Number(verifyCodeInput)) {
      setVerifyDlg(false);
      setFormLoading(true);
      setVerifyCodeInput("");
      handleSubscribe(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vCode, verifyCodeInput]);

  // check Email Response
  useEffect(() => {
    if (emailResponse.message) {
      if (!emailResponse.failed) setVerifyDlg(true);
      setFormLoading(false);
    }
  }, [emailResponse]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: radii.md,
            bgcolor: colors.primaryLight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ContactMailOutlinedIcon sx={{ fontSize: 16, color: colors.primary }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: 15, color: colors.ink }}>
          {translateFront("Contact Us")}
        </Typography>
      </Box>
      <List
        dense
        sx={{
          "& .MuiListItemButton-root": {
            borderRadius: radii.md,
            "&:hover": { bgcolor: colors.primaryLight },
          },
          "& .MuiListItemText-primary": {
            color: colors.ink2,
            fontSize: 14,
          },
        }}
      >
        <ListItem disablePadding>
          <ListItemButton
            onClick={() =>
              window.open(
                contentSettings.footerContactInfo
                  ? contentSettings.footerContactInfo.addressMapLink
                  : "",
                "_blank"
              )
            }
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <HomeWorkIcon sx={{ color: colors.accent, fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={
                contentSettings.footerContactInfo
                  ? contentSettings.footerContactInfo.address
                  : ""
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={handlePhone}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <LocalPhoneIcon sx={{ color: colors.accent, fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={
                contentSettings.footerContactInfo &&
                contentSettings.footerContactInfo.contactNumber &&
                contentSettings.footerContactInfo.contactNumber.length > 0
                  ? contentSettings.footerContactInfo.contactNumber.join(", ")
                  : ""
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() =>
              window.open(
                contentSettings.footerContactInfo
                  ? "mailto:" +
                      contentSettings.footerContactInfo.contactEmailLink
                  : "",
                "_blank"
              )
            }
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <EmailIcon sx={{ color: colors.accent, fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={
                contentSettings.footerContactInfo
                  ? contentSettings.footerContactInfo.contactEmail
                  : ""
              }
            />
          </ListItemButton>
        </ListItem>
      </List>
      <Grid container spacing={1} sx={{ mt: 0.5 }}>
        {webSettings.socialMediaContacts &&
          webSettings.socialMediaContacts.whatsApp !== "" && (
            <Grid item>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, color: colors.primary, "&:hover": { bgcolor: colors.line } }}
                onClick={() =>
                  window.open(
                    webSettings.socialMediaContacts.whatsApp,
                    "_blank"
                  )
                }
              >
                <WhatsApp sx={{ fontSize: 19 }} />
              </IconButton>
            </Grid>
          )}
        {webSettings.socialMediaContacts &&
          webSettings.socialMediaContacts.twitter !== "" && (
            <Grid item>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, color: colors.primary, "&:hover": { bgcolor: colors.line } }}
                onClick={() =>
                  window.open(webSettings.socialMediaContacts.twitter, "_blank")
                }
              >
                <Twitter sx={{ fontSize: 19 }} />
              </IconButton>
            </Grid>
          )}
        {webSettings.socialMediaContacts &&
          webSettings.socialMediaContacts.instagram !== "" && (
            <Grid item>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, color: colors.primary, "&:hover": { bgcolor: colors.line } }}
                onClick={() =>
                  window.open(
                    webSettings.socialMediaContacts.instagram,
                    "_blank"
                  )
                }
              >
                <Instagram sx={{ fontSize: 19 }} />
              </IconButton>
            </Grid>
          )}
        {webSettings.socialMediaContacts &&
          webSettings.socialMediaContacts.telegram !== "" && (
            <Grid item>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, color: colors.primary, "&:hover": { bgcolor: colors.line } }}
                onClick={() =>
                  window.open(
                    webSettings.socialMediaContacts.telegram,
                    "_blank"
                  )
                }
              >
                <Telegram sx={{ fontSize: 19 }} />
              </IconButton>
            </Grid>
          )}
        {webSettings.socialMediaContacts &&
          webSettings.socialMediaContacts.email !== "" && (
            <Grid item>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, color: colors.primary, "&:hover": { bgcolor: colors.line } }}
                onClick={() =>
                  window.open(webSettings.socialMediaContacts.email, "_blank")
                }
              >
                <EmailIcon sx={{ fontSize: 19 }} />
              </IconButton>
            </Grid>
          )}
        {webSettings.socialMediaContacts &&
          webSettings.socialMediaContacts.localPhone !== "" && (
            <Grid item>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, color: colors.primary, "&:hover": { bgcolor: colors.line } }}
                onClick={() =>
                  window.open(
                    webSettings.socialMediaContacts.localPhone,
                    "_blank"
                  )
                }
              >
                <LocalPhoneIcon sx={{ fontSize: 19 }} />
              </IconButton>
            </Grid>
          )}

        {webSettings.additionalSocialContacts &&
          webSettings.additionalSocialContacts.length > 0 &&
          webSettings.additionalSocialContacts.map((x, i) => (
            <Grid item key={i}>
              <IconButton
                sx={{ bgcolor: colors.primaryLight, "&:hover": { bgcolor: colors.line } }}
                onClick={() => window.open(x.pageLink, "_blank")}
              >
                <img
                  alt={x.pageName}
                  src={x.iconUrl}
                  style={{ height: "1.25rem" }}
                />
              </IconButton>
            </Grid>
          ))}
      </Grid>
      {!subScriptionStatus && (
        <>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mt: 2.5, mb: 1.5 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: radii.md,
                bgcolor: colors.primaryLight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <EmailIcon sx={{ fontSize: 16, color: colors.primary }} />
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: 15, color: colors.ink }}>
              {translateFront("Get Updated...")}
            </Typography>
          </Box>
          <Box component="form">
            <TextField
              variant="outlined"
              margin="dense"
              label={translateFront("Enter your email...")}
              size="small"
              fullWidth
              value={subscribeEmail}
              onChange={(e) => setSubscribeEmail(e.target.value)}
              sx={{
                bgcolor: colors.white,
                "& .MuiOutlinedInput-root": {
                  color: colors.ink,
                  "& fieldset": { borderColor: colors.line },
                  "&:hover fieldset": { borderColor: colors.primary },
                  "&.Mui-focused fieldset": { borderColor: colors.accent },
                },
                "& .MuiInputLabel-root": { color: colors.ink3 },
              }}
            />
            <FormControlLabel
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: 12.5,
                  color: colors.ink3,
                },
              }}
              control={
                <Checkbox
                  checked={agreeSub}
                  defaultChecked
                  onChange={(e) => setAgreeSub(e.target.checked)}
                  sx={{
                    color: colors.line,
                    "&.Mui-checked": { color: colors.accent },
                  }}
                />
              }
              label={translateFront(
                "I agree to receive updates & promotional emails"
              )}
            />
            <LoadingButton
              loading={formLoading || customerFormLoading}
              fullWidth
              variant="contained"
              onClick={handleSubscriptionClick}
              disabled={!agreeSub || subscribeEmail === "" ? true : false}
              sx={{
                bgcolor: colors.accent,
                "&:hover": { bgcolor: colors.accentDark },
              }}
            >
              {translateFront("Subscribe")}
            </LoadingButton>
          </Box>
        </>
      )}
      {phoneDlg && (
        <Dialog
          open={phoneDlg}
          onClose={() => setPhoneDlg(false)}
          aria-labelledby={"choose-phone-to-call"}
        >
          <DialogContent>
            {contentSettings.footerContactInfo &&
              contentSettings.footerContactInfo.contactNumber &&
              contentSettings.footerContactInfo.contactNumber.length > 0 &&
              contentSettings.footerContactInfo.contactNumber.map((x, i) => (
                <ListItem disablePadding key={i}>
                  <ListItemButton
                    onClick={() => window.open("tel:" + x, "_blank")}
                  >
                    <ListItemIcon>
                      <LocalPhoneIcon sx={{ color: "darkred" }} />
                    </ListItemIcon>
                    <ListItemText primary={x} />
                  </ListItemButton>
                </ListItem>
              ))}
          </DialogContent>
        </Dialog>
      )}
      {captchaDlg && (
        <Dialog
          open={captchaDlg}
          onClose={() => setCaptchaDlg(false)}
          aria-labelledby={"subscribe-user"}
        >
          <DialogContent>
            <CaptchaTikTakToe
              loginFunc={subscribeUserFunc}
              setCaptchaDlg={setCaptchaDlg}
            />
          </DialogContent>
        </Dialog>
      )}

      {/* Verification dialog */}
      {verifyDlg && (
        <EmailVerificationDialog
          verifyDlg={verifyDlg}
          setVerifyDlg={setVerifyDlg}
          verifyCodeInput={verifyCodeInput}
          setVerifyCodeInput={setVerifyCodeInput}
          countDownStart={countDownStart}
          setCountDownStart={setCountDownStart}
          logic={subscribeUserFunc}
        />
      )}
    </>
  );
}
